module.exports = __webpack_public_path__ + "img/shopping_list_icon.0ccddf21.svg";